import React, { useState } from 'react';
import {
  Navigate,
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import DashboardLayout from './layout/DashboardLayout';
import Home from './pages/Home';
import Employee from './pages/Employee';
import RideHistory from './pages/RideHistory';
import Login from './pages/Login';
import BookRide from './pages/BookRide';
import Profile from './pages/Profile';
import { EmployeeProvider } from './components/EmployeeContext';
import Promotion from './pages/Promotion';

const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderWithLayout = (Component) => (
    <DashboardLayout
      isSidebarOpen={isSidebarOpen}
      toggleSidebar={toggleSidebar}
    >
      {Component}
    </DashboardLayout>
  );

  return (
    <Router>
      <ToastContainer />
      <EmployeeProvider>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/dashboard' element={renderWithLayout(<Home />)} />
          <Route
            path='/employee'
            element={renderWithLayout(
              <Employee setEmployeeData={setEmployeeData} />
            )}
          />
          <Route
            path='/ride-history'
            element={renderWithLayout(<RideHistory />)}
          />
          <Route
            path='/book-ride'
            element={renderWithLayout(<BookRide employeeData={employeeData} />)}
          />
          <Route path='/promotion' element={renderWithLayout(<Promotion />)} />
          <Route path='/profile' element={renderWithLayout(<Profile />)} />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </EmployeeProvider>
    </Router>
  );
};

export default App;
